import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator for ban time field
 * Value must be -1 (permanent ban) or greater than 0 (temporary ban in minutes)
 * Value cannot be 0
 */
export function banTimeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    const numValue = Number(value);

    if (isNaN(numValue)) {
      return { banTime: { message: 'Ban time must be a valid number' } };
    }

    // Check if it's -1 (permanent ban) or greater than 0
    if (numValue === -1 || numValue > 0) {
      return null;
    }

    // Invalid value (0 or negative numbers except -1)
    return {
      banTime: {
        message:
          'Ban time must be -1 (permanent ban) or greater than 0 (minutes)',
        actualValue: numValue,
      },
    };
  };
}
